import {
  put, call, takeEvery, all,
} from 'redux-saga/effects';
import * as actions from '@actions';
import GlossaryService from '@rootCommon/services/glossary';
import { GlossaryDataType } from '@rootCommon/types/glossary';
import { GlossaryPayload } from '@rootCommon/constants/glossaries';

import { AxiosError } from 'axios';
import { GlossaryData } from '../reducers/glossary';

import { SagaGenerator } from './index';

// fetch
function* fetchGlossaryDataAsync(action: { payload: GlossaryPayload }) {
  try {
    const glossaryData: GlossaryDataType[] = yield call(GlossaryService.fetchData, action.payload);

    yield put(actions.fetchGlossaryData.success({ type: action.payload, data: glossaryData }));
  } catch (e) {
    const error = e as AxiosError | Error;
    yield put(actions.fetchGlossaryData.failure(error));
  }
}

function* watchGlossaryData() {
  yield takeEvery(actions.fetchGlossaryData.request, fetchGlossaryDataAsync);
}

// fetch all
function* fetchGlossariesDataAsync(action: { payload: GlossaryPayload[] }) {
  try {
    const glossaries = action.payload;
    const glossaryData: (GlossaryDataType | null)[] = yield all(
      glossaries.map((glossary) => call(GlossaryService.fetchData, glossary || null)),
    );
    const result: GlossaryData = Object.assign(
      {},
      ...glossaries.map((glossary, index) => ({ [glossary]: glossaryData[index] })),
    );

    yield put(actions.fetchGlossariesData.success(result));
  } catch (e) {
    const error = e as AxiosError | Error;
    yield put(actions.fetchGlossariesData.failure(error));
  }
}

function* watchGlossariesData() {
  yield takeEvery(actions.fetchGlossariesData.request, fetchGlossariesDataAsync);
}

// all
function* watchGlossary(): SagaGenerator {
  yield all([watchGlossaryData(), watchGlossariesData()]);
}

export default watchGlossary;
